//TODO enlever jQuery
import {BulbModule} from "../core/bulbModule";
import YouTubePlayer from "youtube-player";
import $ from 'jquery'
import gsap from 'gsap';


export default class extends BulbModule {
    constructor(m) {
        super(m);

        this.isPlayed = false;
        this.$elt = $(this.el);
        this.typeVideo = this.$elt.data('videotype');
        if(this.typeVideo === 'youtube') {
            this.initYoutubePlayer();
            this.$elt.uid = this.$elt.data('uid-youtube');
        }

        this.loopAttr = this.$elt.find('.video__content__mp4Player').data('video-loop')
        if(this.loopAttr !== undefined) {
          this.$elt.find('.video__content__mp4Player')[0].play();
        }

        this.bOn('onEnterViewport', () => {
            console.debug('onEnterViewport')
            if(this.loopAttr !== undefined) {
                this.$elt.find('.video__content__mp4Player')[0].play();
            }

        });

        this.bOn('onExitViewport', () => {
          console.debug('onExitViewport')
            if(this.isPlayed) {
                if(this.typeVideo === 'youtube') {
                    //console.log(this.$elt.player, this.youtubeListener)
                    this.$elt.player.off(this.youtubeListener);
                    this.$elt.player.destroy();
                    this.$elt.player = null;
                    this.youtubeListener = null;
                } else {
                    this.$elt.find('.video__content__mp4Player')[0].pause();
                }
                this.showThumbnail()
                this.isPlayed = false;
            }
        });

        this.events = {
            click: {
                clickPlay: 'clickOnPlay'
            }
        }
    }

    initYoutubePlayer() {
        this.$elt.player = YouTubePlayer(this.$elt.data('uid-elt'));
        this.youtubeListener  = this.$elt.player.on('stateChange', (event) => {
            if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                this.showThumbnail();
            } else if (event.data === YT.PlayerState.PLAYING) {
                this.hideThumbnail();
            }
        });
    }

    destroy() {
        // TODO vérifier que cette destruction fonctionne (fait à l'aveugle)
        if(this.typeVideo === 'youtube') {
            this.$elt.player.off(this.youtubeListener);
        }
    }

    clickOnPlay(){
        if(this.typeVideo === 'youtube') {
            if(this.$elt.player == null) {
                this.initYoutubePlayer();
            }
            this.$elt.player.loadVideoById(this.$elt.uid);
        } else {
            this.$elt.find('.video__content__mp4Player')[0].play();
        }
        this.hideThumbnail();
        this.isPlayed = true;
    }

    /**
     * Masque l'image et le bouton play du player
     */
    hideThumbnail(){
        gsap.to(this.$elt.find('.video__image'), 0.6, {autoAlpha: 0});
        gsap.to(this.$elt.find('.video__image__play'), 0.4, {yPercent: -50});
    }

    /**
     * Affiche l'image et le bouton play du player
     */
    showThumbnail(){
        gsap.to(this.$elt.find('.video__image'), 0.6, {autoAlpha: 1});
        gsap.to(this.$elt.find('.video__image__play'), 0.4, {yPercent: 0});
    }
}




// WEBPACK FOOTER //
// ./scripts/modules/video.js